import { useTranslation } from 'react-i18next';
interface StorageInformationProps {
  isStorageError: boolean;
  isStorageLoading: boolean;
  availableStorageLabel: string;
  usedStorageLabel: string;
  totalStorageLabel: string;
  isOpen: boolean;
}
export const StorageInformation: React.FC<StorageInformationProps> = ({
  isStorageError,
  isStorageLoading,
  availableStorageLabel,
  usedStorageLabel,
  totalStorageLabel,
  isOpen
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <div className="mb-4 rounded-xl border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
      {isStorageLoading ? (
        <p>{t('memoriesTab.loadingStorage', 'Loading storage...')}</p>
      ) : isStorageError ? (
        <p>
          {t(
            'memoriesTab.unableToLoadStorageInfo',
            'Unable to load storage info'
          )}
        </p>
      ) : (
        <div className="space-y-1">
          <p className="font-medium text-gray-900">
            {t('memoriesTab.availableStorage', 'Available storage:')}{' '}
            <span className="text-[#7F9D48]">{availableStorageLabel}</span>
          </p>
          <p>
            {t('memoriesTab.usedStorage', 'Used:')} {usedStorageLabel}
          </p>
          <p>
            {t('memoriesTab.totalStorage', 'Total:')} {totalStorageLabel}
          </p>
        </div>
      )}
    </div>
  );
};
